export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.1.1',
};
//# sourceMappingURL=buildEnv.js.map